import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { CartItem } from '@/types/cart.types';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { CartClearReason } from '@/types/cart-clear-confirmation.types';
import {
  AddMoreProceduresDestination,
  CartClearMotive,
  CartOrigin,
} from '@/types/enums/analytics/cart/cart-analytics.enum';
import { getCartTotal } from '@/utils/cart/get-cart-total.util';

export function trackCartOpened(origin: CartOrigin, items: CartItem[]): void {
  getAnalyticsPlugin().track(AnalyticsEnum.OPEN_CART, {
    origem: origin,
    qtd_itens: items.length,
    valor_total: getCartTotal(items),
  });
}

export function trackAddMoreProcedures(
  origin: CartOrigin,
  items: CartItem[],
  destination: AddMoreProceduresDestination,
): void {
  getAnalyticsPlugin().track(AnalyticsEnum.ADD_MORE_PROCEDURES, {
    origem: origin,
    qtd_itens: items.length,
    destino: destination,
  });
}

const motiveByReason: Record<CartClearReason, CartClearMotive> = {
  [CartClearReason.ADDING_STANDALONE]: CartClearMotive.ADDING_STANDALONE,
  [CartClearReason.CART_HAS_STANDALONE]: CartClearMotive.CART_HAS_STANDALONE,
};

export function trackCartClearConfirmationShown(reason: CartClearReason, items: CartItem[]): void {
  getAnalyticsPlugin().track(AnalyticsEnum.VIEW_CART_CLEAR_CONFIRMATION, {
    motivo: motiveByReason[reason],
    qtd_itens: items.length,
  });
}

export function trackCartClearAnswer(reason: CartClearReason, confirmed: boolean, items: CartItem[]): void {
  getAnalyticsPlugin().track(
    confirmed ? AnalyticsEnum.CONFIRM_CART_CLEAR : AnalyticsEnum.CANCEL_CART_CLEAR,
    {
      motivo: motiveByReason[reason],
      qtd_itens: items.length,
    },
  );
}
